'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuBody = exports.MenuItem = undefined;

var _MenuItem2 = require('./MenuItem');

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

var _MenuBody2 = require('./MenuBody');

var _MenuBody3 = _interopRequireDefault(_MenuBody2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MenuItem = _MenuItem3.default;
exports.MenuBody = _MenuBody3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/default/MenuBody/index.js
// module id = 1683
// module chunks = 0